export default {
  message: {
    Login: {
      badCredentials: 'Bad credentials',
      info: 'Login to manage your account',
      signIn: 'Sign In',
      signInAsAuthor: 'Sign In as Author[Committee user]',
      signInAsGuidelinesAndPublicationsCouncil: 'Sign In as Guidelines and Publications Council',
      signInAsIgo: 'Sign In as Internal Groups Officer',
      signInAsCoWriter: 'Sign In as Co Writer[Committee user]',
      signInAsNDelegate2: 'Sign In as Second National Delegate[National Delegate]',
      signInAsNDelegate: 'Sign In as National Delegate[National Delegate]',
      signInAsReviewer: 'Sign In as Reviewer[Committee user]',
      signInAsReviewer2: 'Sign In as Reviewer Second[Committee user]',
      signInAsSubmitter: 'Sign In as Submitter First[Committee user]',
      signInWithEANM: 'Sign In with EANM',
      signInWithOauth: 'Sign In with EANM OAuth',
      welcome: 'Welcome back',
    },

    Comments: {
      add: 'Leave comment',
      added: 'Comment was added.',
      enterComment: 'Enter comment',
      noComments: 'No comments were added.',
      title: 'Comments',
      fillRequiredFields: 'Comment field is required.',
    },

    Dashboard: {
      adminInfo: 'You have the rights of the Superuser/Office.',
      gpcInfo: 'You have the rights of the Guidelines and Publications Council.',
      igoInfo: 'You have the rights of the Internal Groups Officer.',
      submitterInfo: 'You have the rights of the Submitter.',
      welcome: 'Welcome!',
      Guideline: {
        add: 'Submit new entry',
        list: 'Check your entries',
        check: 'Check entries process',
      }
    },

    Top: {
      helloWelcome: 'Hello, Welcome',
      profile: 'Profile',
      signOut: 'Sign out',
    },

    LeftBar: {
      imprint: 'Imprint',
      additionalWorkNeed: 'Additional work need',
      apps: 'Apps',
      copyright: ' <a href="https://www.eanm.org/">European Association of Nuclear Medicine</a>',
      phone: '+43 1 890 44 27',
      email: '<a class="text-muted" href="mailto:guidelines@eanm.org">guidelines@eanm.org</a>',
      dashboard: 'Dashboard',
      publications: 'Publications',
      logs: 'Logs',
      main: 'Main',
      preApprovedGuidelines: 'Pre approved',
      rejectedGuidelines: 'Rejected',
      settings: 'Settings',
      stats: 'Stats',
      uiexamples: 'UI examples',
      users: 'Users',
      version: 'Client version {version}',
      collapse: 'Collapse',

      Publications: {
        drafts: "Drafts"
      },
    },

    Log: {
      action: 'Action',
      data: 'Data',
      model: 'Model',
      show: 'Show',
      title: 'Logs',
      user: 'User',
      noData: 'There is no data.'
    },

    User: {
      roles: {
        'null': 'Not defined',
        0: 'Office',
        1: 'Guidelines and Publications Council',
        2: 'Committee user',
        3: 'National Delegate',
        4: 'External',
        5: 'Internal Groups Officer',
      },

      steps: {
        0: 'Welcome',
        1: 'Processing CSV data',
        2: 'Verify information',
        3: 'Finalization',
      },

      activated: 'Activated',
      add: 'Add user',
      additionalInfo: 'Additional info',
      additionalInfoEmails: 'Emails need to be unique in the CSV. Rows with same email will be replaced',
      adminEmail: 'Admin email',
      back: "Back",
      changePassword: 'Change password',
      city: 'City',
      columnOrder: 'Column order',
      columnOrderInfo: 'role, first name, last name, email, committee',
      entity: 'Entity',
      committee: 'GPC',
      committeeNotSet: 'NOT SET',
      conflictOfInterest: 'Conflict of interest accepted',
      country: 'Country',
      createdAt: 'Created at',
      csvexample1: 'Example 1 delimiter ","',
      csvexample2: 'Example 2 delimiter ";"',
      CSVinfo: 'CSV without header',
      deleteWarning: 'User "{user}"<br> will be permanently removed from system.',
      email: 'Email',
      enterCsv: 'Enter CSV',
      female: 'Female',
      firstName: 'First Name',
      gender: 'Gender',
      hospital: 'Hospital',
      import: 'Import',
      installationProcess: "Installation process",
      lastName: 'Last name',
      male: 'Male',
      message: 'Message',
      name: 'Name',
      password: 'Password',
      passwordConfirmed: 'Repeat password',
      phone: 'Phone',
      proceed: 'Proceed',
      processUnavailable: 'This process is unavailable or is already finished. To return to main site please click logo on top.',
      regular: 'Regular user',
      role: 'Role',
      rolesLabel: 'Role',
      roleVariants: 'Role variants',
      row: 'Row',
      sendConflictOfInterestReminder: 'Send reminder',
      sendUserReminder: 'User "{name}" &lt;{email}&gt; will get a reminder email.',
      sentCoiUserReminderSuccess: 'Reminder Email was sent successfully.',
      successfullyCreated: 'User "{user}"<br> created successfully.',
      successfullyDeleted: 'User was deleted successfully.',
      successfullyUpdated: 'User "{user}"<br> updated successfully.',
      superuser: 'Superuser',
      updatedAt: 'Updated at',
      userDelete: 'Delete user',
      userDetails: 'User details',
      users: 'Users',
      usersWasImported: 'Users have been imported',
      welcome1: 'This process is only available if there are no rows in the database.',
      welcome2: 'Remember to add an admin user so you will be able to manage the application.',
      welcome: 'Welcome in user import script.'
    },

    Guideline: {
      abbreviationOfCommittee: "Name of the Committee",
      acceptCheckboxes: 'By submitting this manuscript for final EANM GPC/Board approval I confirm that:',
      boardProcessCheckbox1: 'the EANM standard texts (preamble, liability statement, acknowledgement) are included',
      boardProcessCheckbox2: 'I have the authorization of the corresponding author(s) to submit this manuscript for final GPC/Board approval',
      boardProcessCheckbox3: 'I obtained the confirmation of the corresponding author(s) that no further changes to the author block were made and previous changes were announced to the EANM Office',
      boardProcessCheckbox4: 'I obtained the confirmation of the corresponding author(s) that no further changes to the content of the manuscript were following the final feedback by the National Delegates',
      boardProcessCheckbox5: 'I am aware that I need to provide three relevant, non-conflicting reviewers to the Editor in Chief of the Journal I intend to publish',
      acceptedConflictOfInterests: "DOI Form submitted",
      acceptedPublicationManuals: 'I have read all the Publication Manuals',
      acceptedPublicationRules: 'I hereby confirm that the guideline will comply with EANM Publications rules',
      acceptedPublicationRulesAndManuals: 'I hereby confirm that the manuscript will comply with EANM Publication rules and minimum requirements and that the Publications manuals have been read by all the concerned parties',
      acceptedPublicationRulesAndManualsInfo: 'Manuals',
      add: 'Add entry',
      added: 'Guideline was added',
      addFilesToGuideline: "Add files to guideline",
      additionalWorkInfo: 'Please leave your feedback in the comment section below.',
      additionalWorkNeeded: 'Revision required',
      addNewUser: 'Add new User',
      approved: 'Mark as approved',
      approveInfo: 'The entry will be pre-approved and the writing process can begin.',
      approveUserRoleInfo: 'You approve role "{role}"" for user "{username}"',
      boardApprovalApprovedInfo: 'The manuscript will be marked as approved, and will be passed to the publication process',
      boardApprovalonHoldInfo: 'The manuscript will be marked as "on hold".',
      boardApprovalPhase: 'Board approval decision section',
      ccReviewInfo: 'Review by the Guidelines and Publications Council is pending.',
      changes: 'Changes',
      draftChanges: 'Description of modifications',
      draftChangesInfo: '(if any change since the initial proposition to the GPC)',
      draftChangesPlaceholder: 'Please describe if necessary all the modifications that have been done since the original submission to the GPC (I,e title, authors, committees or other societies involved…)',
      clickToAdd: 'Click to add',
      clickToAddInfo: 'Please add the budget items requested for this entry. If items are not required, please tick the corresponding box. A customized timeline will be produced automatically based on the chosen milestones.',
      coaAgreement: 'I confirm that I have provided all data to the best of my knowledge and in agreement with the Corresponding-Author(s)',
      coAuthor: 'EANM Project Leader',
      coAuthors: 'Co-Authors',
      coCoAuthor: 'Corresponding Author',
      coCoAuthorInfo: 'The corresponding author shall be chosen among the authors based on his/her affiliation and the target journal. He/she shall have affiliation with an institution with a “Transformative Agreement” with Springer Nature (formally known as “Compact Deal”). Check <a href="https://www.springernature.com/gp/open-science/oa-agreements" target="_blank">here</a> the list of institutions for EJNMMI.',
      exCoAuthors: 'External Co-Authors',
      coiAccepted: "Accepted",
      coiErrorInfo: 'Attention, you did not provide all required information. Please check the texts highlighted in red.',
      coiManagment: "DOI Management",
      coiNotAccepted: "Not accepted",
      coiNotAcceptedInfo: "Not all authors have submitted their DOI forms to the EANM Office yet. The process is currently on hold. Upload of the first draft will only be possible once all DOI forms have been received. For questions, please contact the EANM Office at guidelines@eanm.org.",
      coiResend: "Resend DOI",
      coiUpdated: "Disclosure of Interest Form submitted",
      committee: 'Guidelines and Publications Council',
      coWriteUsers: 'Co writers',
      dateOfPublication: 'Date of publication',
      deadline: 'Phase deadline',
      deadlineWasUpdated: 'Deadline was updated',
      deletedFileInfo: 'File was successfully deleted',
      deleteFileInfo: 'File will be deleted.',
      deleteWarning: 'Guideline "{name}"<br> will be permanently removed from system.',
      description: 'Description of the entry',
      descriptionPlaceholder: 'Please describe the content and focus of the project in more detail.',
      destination: 'The project is intended to be published in …',
      destinationLabel: 'Targeted Journal',
      details: 'Details',
      doiNumber: 'DOI number',
      DOIwasResend: 'DOI was successfully resend',
      downloadConflictOfInterestPDF: "Download Conflict of Interests PDF",
      downloadReviewersFileInfo: "To upload a new version of the file, please download all the committees’ comments",
      downloadZipped: "Download Zipped",
      draftStored: "Draft was stored successfully.",
      draftUpdated: "Draft was updated successfully.",
      draganddrop: 'Drag and drop here to upload<br>or',
      draganddropUnderButtonSubmitter: "Please name your file including the date of submission",
      draganddropUnderButtonReviewer: "Please name your file including the initials of your committee and the date of submission",
      editorInChiefContacted: 'Editor in Chief contacted',
      editorInChiefContactedDescription: 'I have contacted the Editor in Chief to inform him/her about the aim and scope of this publication and he/she expressed interest in it. This action is not required at the moment, but it is highly recommended. In case of not having contacted the Editor in Chief yet, please do so at your earliest convenience and inform the EANM Office afterwards.',
      empty: 'No guidelines to check at this moment.',
      entity: 'Entity',
      file: 'File',
      fileIncrementVersionNumberAsAdmin: 'Increment Version Number of Document',
      fileFormatExamples: 'File format examples',
      cdsExport: 'Download NucMed CDS Export',
      cdsExportInfo: 'Please send the updated structure to <a href="mailto:guidelines@eanm.org">guidelines@eanm.org</a>.',
      fileSuccessfullyUploaded: 'File was uploaded successfully.',
      fileSuccessfullyUploadedByAdmin: 'File was uploaded successfully by admin.',
      noManuscriptUploaded: 'No manuscript was uploaded. Please upload the file before submitting.',
      fileVersion: "ver.{version}",
      fillRequiredFields: 'Please fill required fields to continue.',
      filterGuidelines: 'Filter guidelines',
      finalPublication: 'Final publication',
      finalPublicationManual: 'Publication Manuals',
      finalPublicationManualData: 'Read the following publication manuals to finalize the guideline',
      finalPublicationData: 'To finalize the guideline fill out following data',
      finalGpcSubmitInfo: 'This will lead to the GPC/Board final approval.',
      finalSubmitInfo: 'This is the last approval step.',
      finalUpload: 'Final upload section',
      forwardToCommittee: "Forward to Committee/ND",
      forwardToNatDel: "Forward to National Delegates",
      forwardToNationalDelegates: "Proceed",
      toCommitteeReview: "Committee Review",
      toParallelReview: "Parallel Review",
      toNationalDelegates: "National Delegates",
      forwardToCommitteeInfo: 'Draft will be passed to Committee for review.',
      forwardToParallelReviewInfo: 'Manuscript will be passed to the Committee and the National Delegates for simultaneous review.',
      sectionParallelReviewDecision: 'Parallel review decision',
      guidelineParallelDecision: 'Both the Committee and the National Delegates have finished their review. Proceed to the next step, or send the manuscript back for another review round — Committee, National Delegates, or another Parallel round.',
      parallelReviewDecision: 'Parallel review decision',
      parallelProceed: 'Proceed',
      parallelProceedInfo: 'The manuscript will proceed to the next step (preparation of the final version).',
      parallelAnotherRound: 'Another parallel review round',
      parallelAnotherRoundInfo: 'The manuscript will be sent back to the Committee and the National Delegates for another parallel review round.',
      skipNdReview: 'Skip ND review',
      skipNdReviewInfo: 'The National Delegates have already reviewed this manuscript, so their review will be skipped and the manuscript will proceed to the next step.',
      forwardToNationalDelegatesInfo: 'Manuscript will be passed to National Delegates users for review.',
      gpcFinalApprovalPhase: 'Guideline and Publications approval decision section',
      guidelineToCommittee: "Trigger another Committee Review round (if available) or forward to the National Delegates.",
      guidelineToNationalDelegates: "Manuscript will be passed to National Delegates users for review.",
      guidelineWasReviewed: 'Guideline was reviewed.',
      indicateJournal: 'Indicate journal',
      indicatePublisher: 'Indicate publisher',
      kindsOfWorkJointDetaild: 'Which society(ies)? Did you already contact them informally? \n' + 'Do you have already name of possible representatives?',
      kindsOfWorkLabel: 'The guideline is intended to be written as …',
      looksGood: 'Everything looks good, no files will be upload.',
      max1000: '(max 1000 words)',
      max20words: '(max 20 words)',
      maxWordsError: 'Max count words for this field is ',
      minimumRequirementsMet: 'The manuscript will comply with all the minimum requirement',
      modification: 'Changes made after draft submission to GPC',
      my_role: 'My role',
      myCommittee: "My Committee's Projects",
      myNationalDelegateRole: 'Your role in this guideline is National Delegate Reviewer.',
      myReviewerRole: 'Your role in this manuscript is Reviewer.',
      myGPCRole: 'Your role in this guideline is Guidelines and Publications Council.',
      name: 'Working title',
      nameOfJournal: 'Name of journal',
      namePlaceholder: 'max 20 words',
      necessaryContacts: 'All the necessary contacts (other committees/ societies) have been taken',
      ndLooksGood: 'Everything looks good.',
      nextStep: 'Next step',
      noCommentEverythingok: "No comment, everything ok.",
      otherCommittees: "Other Committees' Projects",
      otherJournalPlaceholder: 'Insert details about publisher',
      others: "General",
      phase0: 'Saved as draft',
      phase100: 'Preparation of final version',
      phase10: 'GPC/Office Formal Check',
      phase102: 'Under GPC final approval',
      phase104: 'GPC approval on hold',
      phase110: 'Board final approval',
      phase120: 'In publication process',
      phase130: 'Board approval on hold',
      phase140: 'Published',
      phase30: 'Entry under revision',
      phase40: 'Writing in process',
      phase42: 'Under GPC review',
      phase44: 'Implementing GPC review',
      phase46: 'Pending release to Committee/ND',
      phase50: 'Under committee review',
      phase52: 'Under review',
      phase54: 'Implementing parallel review',
      phase56: 'Pending parallel review decision',
      phase60: 'Implementing committee review',
      phase70: 'Pending release to ND review',
      phase80: 'Under ND review',
      phase90: 'Implementing ND review',
      phase: 'Phase',
      preApprove: 'Approve entry',
      preApproveDraft: 'Entry approved',
      preApproveDraftConfirm: 'Was this Entry submitted and approved by the GPC?',
      preApproveDraftWarning: 'Please contact the EANM Executive Office!',
      preApproveDraftInfo: 'Every proposal needs to be first submitted to the GPC. This should be done during the topics collect at the beginning of the year or per email via ' + '<a className="text-muted" href="mailto:guidelines@eanm.org">guidelines@eanm.org</a>',
      preApproved: 'Pre-approved',
      previousStep: 'Previous step',
      proceduresStandardsText: 'I confirm that the',
      proceduresStandardsLink: 'EANM Guidelines Procedures Compulsory Standard Texts',
      proceduresStandardsIncluded: 'are included.',
      progress: 'Progress',
      publicationInfo: 'Text explanation / description',
      publications: 'Publications',
      publishWarning: 'No further changes are possible after submitting the entry.',
      putOnHold: 'Put on hold',
      reject: 'Reject',
      goToReviews: 'Go to reviews',
      rejectInfo: 'The entry will be rejected. No further edits will be possible.',
      rejectTextboxPlaceholder: 'Leave comment...',
      resendDOIconfirm: "Email with DOI will be send to {user}<{email}>",
      reviewer: 'Reviewer',
      reviewerComment: 'Leave comment if you wish.',
      reviewGuideline: "Review Guideline",
      reviewUsers: 'Reviewers',
      saveDraft: 'Save draft',
      section1: 'Base data',
      section2: 'Definition of involved parties',
      section3: 'Entry-specific information',
      section4: 'Publication',
      section5: 'Budget',
      section6: 'Conflict of Interest',
      section7: 'Finalising the entry submission phase',
      sectionBoardProcess: 'Guideline Board Process',
      sectionFilesUploaded: 'File uploads so far',
      sectionFileUpload: 'Upload draft',
      sectionFinalPublication: 'Final publication',
      sectionForwardToCommitteeReview: "Forward to Committee Review or National Delegates",
      sectionForwardToNationalDelegates: "Forward to National Delegates",
      sectionNationalDelegatesReview: "National Delegates review",
      sectionReuploadFiles: 'Feedback on revised version of the draft',
      sectionGpcReviewed: 'Feedback received from GPC Reviewers',
      sectionReviewed: 'Feedback received from Reviewers',
      sectionUploadedFiles: 'Uploaded files',
      selectFiles: "Select Files",
      selectOptionLabel: 'Please select an option',
      sendConflictOfInterestEmail: "Send Conflict of Interests Email",
      sendConflictOfInterestEmailInfo: "An E-Mail containing the Disclosure of Interest form will be forwarded to all involved parties after the entry has been pre-approved by the GPC. The completion of all DOI forms is a prerequisite for the first draft to be uploaded for review.",
      sendCommentsToSubmitter: "Send comments to submitter",
      showAll: "Show all",
      showMyTodos: "Show my todos",
      showNdReview: "Download Manuscript",
      showReview: "Show reviews",
      showGPCFiles: "Show GPC files",
      showFiles: "Show files",
      showReviewButton: "Show revised version",
      showSavedDrafts: "Show saved drafts",
      showUploadedFiles: 'Show uploaded files',
      showUploadFiles: 'Show upload files',
      startBoardProcess: "Start GPC/Board final approval process",
      startBoardProcessInfo: "At this point you can start the board process.",
      startGPCReview: "Start my GPC review",
      startReview: "Start my review",
      startUpload: 'Upload draft',
      startFirstDraft: 'Upload first Draft',
      submit: 'Submit entry',
      submitLabel: 'I hereby submit the manuscript for GPC/Board final approval',
      submitNationalDelegateReview: "Submit review",
      submitNationalDelegateReviewInfo: "This action will push the manuscript forward.",
      submitReviewed: 'Submit my review',
      submitSection: 'Final submit section',
      submittedInfo: 'Entry has proceeded to the phase "GPC/Office Formal Check".',
      submitter: 'Submitter',
      submitter_name: 'Submitter',
      successfullyAWN: 'Return to my To-Dos.',
      successfullyGpcFinalApproved: 'GPC approved.',
      successfullyboardApproved: 'Board approved.',
      successfullyDeleted: 'Guideline was deleted successfully.',
      successfullyForwardToCommittee: 'Forwarded to Committee Review',
      successfullyForwardToParallel: 'Forwarded to Parallel Review',
      successfullyParallelProceed: 'Proceeded to the next step',
      successfullyParallelAnotherRound: 'Sent back for another parallel review round',
      successfullySkipNdReview: 'ND review skipped; proceeded to the next step',
      successfullyForward: 'Forwarded to National Delegates',
      successfullyNDReviewed: "Review was submitted successfully.",
      successfullyPreApproved: 'Guideline was pre-approved',
      successfullyPuttedOnHold: "Guideline was put on hold successfully.",
      successfullyRejected: 'Your entry has been rejected.',
      successfullySubmitted: 'The entry has been submitted.',
      successfullyFirstUpload: 'Your entry has been submitted for review successfully.',
      successfullyUploaded: 'Your manuscript has been submitted for final EANM GPC/Board approval successfully.',
      successfullyReUploaded: 'The revised version of the draft has been submitted successfully.',
      termsConditions: 'I have read and understood the process explanation and accept the terms & conditions.',
      titleIncludesEanm: 'The manuscript title includes EANM in it',
      type: 'Type of Manuscript',
      typeLabelChoose: 'Please select an type',
      underCommitteeReview: "Under committee review",
      uniqueId: 'Unique ID',
      updateDraft: 'Save updated draft',
      upload: 'Upload files',
      uploadNameInfo: 'Please name your file including the initials of your committee and the date of submission.',
      uploadCorrectedFiles: 'Upload corrected files',
      uploadedForReviewFilesInfo: 'Guideline Files that were uploaded for review by the submitter',
      uploadFile: 'Upload File',
      uploadGpcOnHoldFile: 'Upload File for on Hold',
      uploadFiles: 'Upload Files',
      uploadFilesInfo: 'Click link below to start uploading files to the guideline',
      uploadForUser: 'Upload files as user',
      gpcFinalHoldInfo: 'New Clean Version will be upload, no further amendments will be possible.',
      uploadGuidelineInfo: 'The draft will be uploaded, no further amendments will be possible until the revision phase has ended.',
      uploadId: 'Upload ID',
      waitingForReview: 'Waiting for review.',
      withComment: 'With comment',
      wordCount: 'Current word count:',
      youNeedToWrtiteSomething: 'You need to write something!',
      yourFeedbackAYS: 'Are you sure that you wish to submit this feedback?',
      yourFeedbackSubmitInfo: 'No further edits will be possible.',
      yourFeedbackSubmitted: 'Your feedback has been submitted.',
      yourNextSteps: "Your next steps",

      AI: 'Artificial Intelligence',
      BJ: 'Bone & Joint Committee',
      CV: 'Cardiovascular',
      DO: 'Dosimetry',
      ET: 'Ethics',
      II: 'Inflammation & Infection',
      NI: 'Neuroimaging',
      OT: 'Oncology & Theranostics',
      PA: 'Paediatrics',
      PH: 'Physics',
      DD: 'Policy & Regulatory Affairs',
      RP: 'Radiation Protection',
      RS: 'Radiopharmaceutical Sciences',
      RY: 'Radiopharmacy',
      TE: 'Technologist',
      TY: 'Thyroid',
      MI: 'Translational Molecular Imaging & Therapy',
      YP: 'Young Professionals',

      coAuthorsForm: {
        title: 'Adding new co author',
        save: 'Save new user',
      },

      destinationsOfManuscript: {
        'null': 'N/A',
        0: 'EANM Journal',
        1: 'EANM Innovation',
        2: 'Other journal',
      },

      kindsOfWork: {
        0: 'EANM-only',
        1: 'Jointly with other society',
      },

      Milestones: {
        budget: "Budget €",
        Budget: 'Budget',
        budgetInvalid: 'must be numeric and may contain 2 decimal points.',
        budgetUpdated: 'Budget successfully updated',
        chooseStartDate: 'Choose due date',
        clickUpdateToSaveChanges: 'Click update to save changes',
        deleteInfo: 'The deleted elements will be removed after the entry has been submitted.',
        dueDate: 'Due date',
        info: 'Please note, this timeline is a forecast of the ideal scenario for the publication, based on the EANM publications management process and its internal deadlines. The timeline is subject to change.',
        label: 'Milestones',
        M10: 'Final draft uploaded for Board approval',
        M11: 'Guideline is Board approved',
        M12: 'Publication details submitted',
        M13: 'Milestone 13',
        M14: 'Milestone 14',
        M1: 'Entry submitted',
        M2: 'Guideline pre-approved',
        M3: 'DOI Forms due',
        M4: 'Draft for Committee review uploaded',
        M4_2: 'GPC review completed',
        M4_4: 'GPC Revised version uploaded',
        M5: 'Committee review completed',
        M6: 'Revised version uploaded',
        M7: 'Revised version approved',
        M8: 'Draft for National Delegate review uploaded',
        M9: 'National Delegate review completed',
        medical: 'Methodologist and/or Language review',
        meeting: 'Meeting',
        meta: 'Meta-analysis \\ Systematic review \\ Evidence-creation',
        metaHtml: 'Meta-analysis<br> Systematic review<br> Evidence-creation',
        metaButtonShortLabel: 'Meta-analysis',
        methodologistHtml: 'Methodologist<br> and/or<br> Language review',
        noBudget: 'No budget was planned!',
        noMilestoneSet: 'This budget item is not required',
        publication: 'Publication Fee',
        estimatedTimeline: 'Estimated Timeline',
        timeline: 'Timeline',
        title: 'Title',
        titlePlaceholder: 'Enter title',
        toggleTableView: 'Show/Hide table view',
        type: 'Type',
      },

      nationalDelegatesReview: {
        looksGood: "Looks good",
        minor: "Minor comments",
        major: "Major comments",
      },

      publicationJournals: {
        0: 'EANM',
      },

      uploadedReview: {
        noChanges: 'No changes',
        minor: 'Minor changes',
        major: 'Major changes',
      },

      RoleAcceptance: {
        accept: 'Accept',
        acceptWarning: 'You will be marked as co author of this guideline.',
        change: 'Change role',
        changeInfo: 'I would like to play a role',
        changeRequestInProgress: 'Change role from "{origin}" to "{requested}". Waiting for decisions.',
        changeRequestWasSend: 'Change request was send.',
        changeTextboxPlaceholder: 'Feel free to leave a comment about your decision.',
        changeWarning: 'If change is approved, you will be notify via email.',
        reject: 'Reject',
        rejectTextboxPlaceholder: 'Feel free to leave a comment about your decision.',
        rejectWarning: 'You will be excluded from this guideline as co author.',
        roleAcceptedInfo: 'You accepted role "{role}" on this guideline',
        roleInfo: 'You have been selected to be "{role}" on this guideline. Do you accept this role?',
        roleRejectedInfo: 'You rejected role of "{role}" on this guideline with comment "{comment}"',
        roleWasAccepted: 'Role was accepted',
        roleWasRejected: 'Role was rejected',
        submitChangeRequest: 'Submit change request',
        title: 'Role acceptance',

        roles: {
          1: 'Co Author',
          2: 'Reviewer',
          3: 'Co Writer',
        },

        status: {
          0: 'Unconfirmed',
          1: 'Accepted',
          2: 'Rejected',
          3: 'Change request',
        },
      },

      reviewType: {
        change0: 'No changes',
        change1: 'Minor changes',
        change2: 'Major changes',
      },

      typesOfManuscript: {
        'null': 'N/A',
        0: 'Procedural Guideline',
        1: 'Clinical Guideline',
        2: 'Other publications',
      },
    },

    Sample: {
      input: 'Input field',
      radio: 'Radio field',
      textarea: 'Textarea field',
    },

    Statistic: {
      stats: 'Statistics',
      dateRange: 'Date range',
      generate: 'Generate statistics',
      statisticTitle: 'Statistic from {dateFrom} to {dateTo}',
      phase: 'Phase',
      nonSpecified: 'Non specified',
      download: 'Download',
    },

    Settings: {
      settings: 'Settings',
      officeEmail: 'Office email',
      officeEmailOverride: 'Override office email',
      successfullyUpdated: 'Settings successfully updated',
    },

    add: 'Add',
    apply: 'Apply',
    approve: 'Approve',
    areYouSure: 'Are you sure?',
    cancel: 'Cancel',
    chooseProperDate: 'Choose proper date',
    close: 'Close',
    confirmDelete: 'Yes, im sure.',
    connectionError: 'Connection error.',
    createdAt: 'Created at',
    delete: 'Delete',
    deleted: 'Deleted',
    deleteQuestion: 'Are you sure you want to to delete the record below?',
    download: 'Download',
    edit: 'Edit',
    error: 'Error',
    fieldRequired: ' - field required',
    fieldRequiredInfo: 'This field is required',
    fillRequiredFields: 'Please fill required fields to continue.',
    forbidden: 'Forbidden!',
    hideDetails: 'Hide details',
    incorrectValue: 'Please provide a correct value.',
    link: 'Download the Terms & Conditions here',
    markedToDel: 'The milestone element will be deleted.',
    modify: 'Modify',
    na: 'N/A',
    no: 'No',
    noCancel: 'I need a few more changes - please return!',
    noChosen: 'No chosen',
    noData: 'No data...',
    notFoundError: 'Not found.',
    return: 'Return',
    save: 'Save',
    selectAll: 'Select all',
    showDetails: 'Show details',
    submit: 'Submit',
    success: 'Success',
    successfullyAdded: 'Successfully added',
    successfullyUpdated: 'Successfully updated',
    thisActionIsForbidden: 'This action is forbidden',
    title: 'Guideline Manager',
    unauthenticated: 'This action is unauthenticated',
    unprocessable: 'Unprocessable entry',
    unselectAll: 'Unselect all',
    update: 'Update',
    updatedAt: 'Updated at',
    valueNotMatch: 'Entered values not match',
    view: 'View',
    warning: 'Warning',
    yes: 'Yes',
    yesImSure: 'Yes, I am sure.',
    yesSubmit: 'Yes, I am sure.',

    Imprint: {
      title: 'Imprint',
      publisher: {
        title: 'Publisher',
        content: '<p>\
            European Association of Nuclear Medicine (EANM)<br>\
            Schmalzhofgasse 26<br>\
            1060 Vienna<br>\
            Austria\
          </p>\
          <p>Phone: +43 1 890 44 27<br>\
            Fax: +43 1 890 44 27-9<br>\
            Mail:&nbsp;<a href="mailto:office@eanm.org">office@eanm.org</a>\
          </p>\
          <p>\
            Data Protection Act: Registration no. 1068431<br>\
            Austrian Register of Associations: no. 063483520<br>\
            Zentrales Vereinsregister (ZVR)-Zahl: 063483520\
          </p>',
      },
      contents: {
        title: 'Responsible for the contents',
        content: '<p>\
            Jolanta Kunikowska<br>\
            EANM President 2021-2022<br>\
            Medical University of Warsaw<br>\
            Nuclear Medicine Department<br>\
            ul.Banacha 1 a<br>\
            02-097 Warszawa<br>\
            POLAND\
          </p>',
      },
      editorial: {
        title: 'Editorial Office',
        content: '<p>\
            European Association of Nuclear Medicine (EANM)<br>\
            Schmalzhofgasse 26<br>\
            1060 Vienna<br>\
            Austria<br>\
            <a href="mailto:office@eanm.org">office@eanm.org</a>\
          </p>',
      },
      programming: {
        title: 'Consulting, Programming',
        content: '<p>\
            CodeCove OG<br>\
            Phone: +43 680 325 97 83<br>\
            Web: <a href="http://www.codecove.at">www.codecove.at</a><br>\
            Mail: <a href="mailto:info@codecove.at">info@codecove.at</a>\
          </p>',
      },
      disclaimer: {
        title: 'Disclaimer',
        content: '<p>\
            The EANM will use reasonable efforts to include accurate and up-to-date information on this Web Site, but the\
            EANM makes no warranties or representations as to its accuracy and expressly disclaims any obligation to\
            update said information. All users agree that they access and use this Web Site at their own risk. The EANM\
            has not reviewed all of the sites that may be linked to this Web Site and makes no warranties or\
            representations as to the accuracy and/or any other aspect of the information contained in any off-site pages\
            or any other site linked to this Web Site. All users agree that the linking is at their own risk. The text on\
            this website is licensed under a Creative Commons <a href="http://creativecommons.org/licenses/by-sa/3.0/"\
            target="_blank" rel="noopener">Attribution-ShareAlike 3.0 Unported License</a>.\
          </p>',
      },
    },
  },
}
